// Cross-platform storage surface (native counterpart in FirebaseStorage.ts).
// `ref(storage, url)` already resolves full https download URLs on web, so no URL helper is needed.
export * from "firebase/storage";
export const putFile = null; // putFile is native-only; never called on web.
